import { SiteSettings } from '@hb/shared'
import { create } from 'zustand'

import createSelectors from './selectors'

// Define a store for managing collections

const useSiteSettingsBase = create<SiteSettings>(() => ({
  nativeDateInputOverride: false,
}))

// const publishToSubscriber

export const useSiteSettings = createSelectors(useSiteSettingsBase)

export const updateSiteSettings = (key: keyof SiteSettings, value: any) => {
  useSiteSettingsBase.setState({ [key]: value })
}

export const initializeSiteSettings = (initSettings: Partial<SiteSettings>) => {
  useSiteSettingsBase.setState(initSettings)
}
